function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import "regenerator-runtime/runtime.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.assign.js";
import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useUser, Tabs, Tab, ListHeader, FranchiseeDetailsTab, FranchiseeDepositsTab, FranchiseeFundsTab } from 'components';
import { showApiError } from 'utils';
import { getFranchisee, getAllFranchiseeDepositsBalance, getFranchiseeFundsDepositBalance } from 'services';
import { jsx as ___EmotionJSX } from "@emotion/react";

var FranchiseeDetails = function FranchiseeDetails(_ref) {
  var _location$state, _match$params;

  var location = _ref.location,
      match = _ref.match;

  var _useUser = useUser(),
      userInfo = _useUser.userInfo;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      _ref2$franchisee = _ref2.franchisee,
      franchisee = _ref2$franchisee === void 0 ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.franchisee : _ref2$franchisee;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      _ref3$franchisesId = _ref3.franchisesId,
      franchisesId = _ref3$franchisesId === void 0 ? userInfo === null || userInfo === void 0 ? void 0 : userInfo.franchisee_id : _ref3$franchisesId;

  var _useState = useState(franchisee),
      _useState2 = _slicedToArray(_useState, 2),
      franchiseeData = _useState2[0],
      setFranchiseeData = _useState2[1];

  var _useState3 = useState(),
      _useState4 = _slicedToArray(_useState3, 2),
      depositBalance = _useState4[0],
      setDepositBalance = _useState4[1];

  var _useState5 = useState(),
      _useState6 = _slicedToArray(_useState5, 2),
      fundsBalance = _useState6[0],
      setFundsBalance = _useState6[1];

  useEffect(function () {
    fetchFranchiseeData();
    fetchDepositsBalance();
    fetchFundsDepositsBalance();
  }, []);

  var fetchFranchiseeData = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getFranchisee, _yield$getFranchisee2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getFranchisee(franchisesId);

            case 2:
              _yield$getFranchisee = _context.sent;
              _yield$getFranchisee2 = _slicedToArray(_yield$getFranchisee, 2);
              res = _yield$getFranchisee2[0];
              err = _yield$getFranchisee2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setFranchiseeData(function (prev) {
                return _objectSpread(_objectSpread({}, prev), res);
              });

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchFranchiseeData() {
      return _ref4.apply(this, arguments);
    };
  }();

  var fetchDepositsBalance = /*#__PURE__*/function () {
    var _ref5 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var _yield$getAllFranchis, _yield$getAllFranchis2, res, err;

      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getAllFranchiseeDepositsBalance({
                franchisee: franchisesId
              });

            case 2:
              _yield$getAllFranchis = _context2.sent;
              _yield$getAllFranchis2 = _slicedToArray(_yield$getAllFranchis, 2);
              res = _yield$getAllFranchis2[0];
              err = _yield$getAllFranchis2[1];

              if (!err) {
                _context2.next = 8;
                break;
              }

              return _context2.abrupt("return", showApiError(err));

            case 8:
              setDepositBalance(res);

            case 9:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function fetchDepositsBalance() {
      return _ref5.apply(this, arguments);
    };
  }();

  var fetchFundsDepositsBalance = /*#__PURE__*/function () {
    var _ref6 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _yield$getFranchiseeF, _yield$getFranchiseeF2, res, err;

      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return getFranchiseeFundsDepositBalance({
                franchisee: franchisesId
              });

            case 2:
              _yield$getFranchiseeF = _context3.sent;
              _yield$getFranchiseeF2 = _slicedToArray(_yield$getFranchiseeF, 2);
              res = _yield$getFranchiseeF2[0];
              err = _yield$getFranchiseeF2[1];

              if (!err) {
                _context3.next = 8;
                break;
              }

              return _context3.abrupt("return", showApiError(err));

            case 8:
              setFundsBalance(res);

            case 9:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    return function fetchFundsDepositsBalance() {
      return _ref6.apply(this, arguments);
    };
  }();

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(ListHeader, {
    title: (franchiseeData === null || franchiseeData === void 0 ? void 0 : franchiseeData.name) || 'Кредитен посредник'
  }), ___EmotionJSX(Tabs, {
    startingRoute: match.url,
    noAnimation: true,
    contentClass: "container-xxl",
    listClass: "container-xxl",
    padding: "0 2em"
  }, ___EmotionJSX(Tab, {
    url: "/info",
    component: function component(data) {
      return ___EmotionJSX(FranchiseeDetailsTab, _extends({}, data, {
        franchisee: franchiseeData,
        onUpdate: function onUpdate(data) {
          return setFranchiseeData(data);
        }
      }));
    },
    label: "\u0414\u0435\u0442\u0430\u0439\u043B\u0438"
  }), !(franchiseeData !== null && franchiseeData !== void 0 && franchiseeData.is_tenant) && ___EmotionJSX(Tab, {
    url: "/deposits",
    component: function component(data) {
      return ___EmotionJSX(FranchiseeDepositsTab, _extends({}, data, {
        depositBalance: depositBalance,
        fundsBalance: fundsBalance,
        id: franchisesId,
        onAddSubtract: fetchDepositsBalance
      }));
    },
    label: "\u0414\u0435\u043F\u043E\u0437\u0438\u0442\u0438"
  }), ___EmotionJSX(Tab, {
    url: "/funds",
    component: function component(data) {
      return ___EmotionJSX(FranchiseeFundsTab, _extends({}, data, {
        depositBalance: depositBalance,
        fundsBalance: fundsBalance,
        id: franchisesId,
        onAddSubtract: fetchFundsDepositsBalance
      }));
    },
    label: "\u0421\u0440\u0435\u0434\u0441\u0442\u0432\u0430"
  })));
};

FranchiseeDetails.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object
};
export default FranchiseeDetails;